module.exports = __webpack_public_path__ + "cdd96369fee1459a98e814dbce742722.png";